import { render, staticRenderFns } from "./NoticeBoardDetail.vue?vue&type=template&id=6e73cd99&"
import script from "./NoticeBoardDetail.vue?vue&type=script&lang=ts&"
export * from "./NoticeBoardDetail.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeBoardDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports